<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const listAddRef = ref();
const optionFields = ref({
  'page_size' : 30,
});
const fields = ref([
  {field_name: 'コード', field_key: 'wholesaler.wholesaler_code', width: '20%', align: 'text-center'},
  {field_name: '卸業者名', field_key: 'wholesaler.wholesaler_name', width: '60%', align: 'text-left'},
  {field_name: '', field_key: 'action', width: '20%', align: 'text-center'}
]);

const wholesalerFields = ref([
  {field_name: 'コード', field_key: 'wholesaler_code', width: '20%', align: 'text-center'},
  {field_name: '卸業者名', field_key: 'wholesaler_name', width: '60%', align: 'text-left'},
  {field_name: '', field_key: 'action', width: '20%', align: 'text-center'}
]);

const handler = (name:string,value:Object,eof:Boolean=false) => {
}

const isShowAddDialog = ref(false);
const showAddDialog = () => {
  listAddRef.value.clearSearch();
  listAddRef.value.resetItem();
  isShowAddDialog.value = true;
}
const closeAddDialog = () => {
  isShowAddDialog.value = false;
}
const isAddLoading = ref(false);
const addWholesaler = (item) => {
  isAddLoading.value = true;
  let params = new FormData();
  params.append('wholesaler_id', item.id);
  axios(props.apis.pharmacy_update_wholesaler,{method:"post",data:params})
  .then((response) => {
    isShowAddDialog.value = false;
    listRef.value.resetItem(config.LIST_DELAY);
  })
  .catch((error) => {
    isAddLoading.value = false;
    errorAlert(error);
  })
  .then(() => {
    //always
    isAddLoading.value = false;
  });
}
const isLoadingDialog = ref(false);
const deletePharmacyWholesalerConfirm = async (item) => {
  let result = await confirmAlert('削除してもよろしいですか？');
  if (result.isConfirmed) {
    deletePharmacyWholesaler(item);
  }
}
const deletePharmacyWholesaler = (item) => {
  isLoadingDialog.value = true;
  let params = new FormData();
  params.append('wholesaler_id', item.wholesaler.id);
  axios(props.apis.pharmacy_delete_wholesaler,{method:"post",data:params})
  .then((response) => {
    listRef.value.deleteItem(item);
  })
  .catch((error) => {
    isLoadingDialog.value = false;
    errorAlert(error);
  })
  .then(() => {
    isLoadingDialog.value = false;
  });
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="wholesaler_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
    <div>
        <a href="javascript:void(0)" @click="showAddDialog" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">取引卸追加</a>
    </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :api-url="apis.pharmacy_wholesaler_list"
        :option-fields="optionFields"
        height="72vh"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key != 'action'" :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
          <div v-else :class="field.align">
            <a href="javascript:void(0)" @click="deletePharmacyWholesalerConfirm(slotProps.item)"><i class="fa-solid fa-trash-can"></i></a>
          </div>
        </td>
      </template>
      </custom-list>
      <div></div>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isShowAddDialog"
  width="60%"
  :close="closeAddDialog"
  :isLoading="isAddLoading"
>
  <template v-slot:header>
    卸業者選択
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <custom-list
      ref="listAddRef"
      :table-fields="wholesalerFields"
      :is-searchable="true"
      place-holder="卸業者コードを入力してください"
      height="20em"
      :option-fields="{page_size:30,self_except:1}"
      :api-url="apis.wholesaler_list"
    >
    <template v-slot:item="slotProps">
      <td v-for="(field,index) in wholesalerFields" :key="index" :style="'width:' + field.width">
        <div v-if="field.field_key != 'action'" :class="field.align">
          {{ getFieldValue(slotProps.item,field.field_key) }}
        </div>
        <div v-else :class="field.align">
          <a href="javascript:void(0)" @click="addWholesaler(slotProps.item)"><i class="fa-solid fa-circle-plus"></i></a>
        </div>
      </td>
    </template>
    </custom-list>
  </div>
  </template>
</modal-dialog>

</template>

